import { Component, OnInit } from '@angular/core';
import { SharedService } from '../../services/shared/shared.service';

@Component({
  selector: 'app-layout',
  templateUrl: './layout.component.html',
  styleUrls: ['./layout.component.css']
})
export class LayoutComponent implements OnInit {
  constructor(public sharedService: SharedService) { }
  public menuFolded;
  ngOnInit() {
    this.sharedService.updateTheme();
    this.sharedService.updateUserInfoSource();
    if(this.sharedService.appMenuFolded){
      this.sharedService.appMenuFolded.subscribe(menufolded => {
        this.menuFolded = menufolded;
      });
    }
  }

}
